<template>
    <div class="contact-floating flex-col">

        <div class="box_93 flex-col">
            <div class="group_3 flex-col">
                <div class="box_11 flex-row">
                    <span class="text_18">联系我们</span>
                    <img
                            @click="close"
                            class="thumbnail_1"
                            referrerpolicy="no-referrer"
                            src="../../assets/common/index_contact_01.png"
                    />
                </div>
                <div class="box_12 flex-row">
                    <div class="image-text_159 flex-row justify-between">
                        <img
                                class="thumbnail_2"
                                referrerpolicy="no-referrer"
                                src="../../assets/common/index_contact_02.png"
                        />
                        <span class="text-group_2">姓名</span>
                    </div>
                    <input
                            class="form-input"
                            v-model="formData.name"/>
                </div>
                <div class="box_13 flex-row">
                    <div class="image-text_160 flex-row justify-between">
                        <img
                                class="thumbnail_3"
                                referrerpolicy="no-referrer"
                                src="../../assets/common/index_contact_02.png"
                        />
                        <span class="text-group_3">电话</span>
                    </div>
                    <input class="form-input" v-model="formData.phone"/>
                </div>
                <div class="box_13 flex-row">
                    <div class="image-text_160 flex-row justify-between">
                        <img
                                class="thumbnail_3"
                                referrerpolicy="no-referrer"
                                src="../../assets/common/index_contact_02.png"
                        />
                        <span class="text-group_3">公司</span>
                    </div>
                    <input class="form-input" v-model="formData.company"/>
                </div>

                <div class="text-wrapper_5 flex-row">
                    <span class="text_20">邮箱</span>
                    <input
                            class="form-input"
                            v-model="formData.email"/>
                </div>
                <div class="text-wrapper_6 flex-col">
                    <textarea class="message-input" v-model="formData.content" placeholder="在此留言（最多100字）" maxlength="100"></textarea>
                </div>
                <div class="text-wrapper_7 flex-col" @click="handleClick()">
                    <span class="text_22">提交</span>
                </div>

            </div>

        </div>

    </div>
</template>
<script>
    import {isNull,validateEmail} from "../../common/testFun";

    export default {
        data() {
            return {
                formData: {
                    name: '',
                    company: '',
                    phone: '',
                    email: '',
                    content: ''
                },
            };
        },
        methods: {
            resetForm() {
                this.$set(this, 'formData', {
                    name: '',
                    company: '',
                    phone: '',
                    email: '',
                    content: ''
                });
            },
            validatePhoneNumber(phone) {
                debugger
                // 先移除所有空格
                const cleanedPhone = phone.replace(/\s+/g, '');

                // 检查是否包含"转"字
                if (cleanedPhone.includes("转")) {
                    // 分割主号码和分机号
                    const parts = cleanedPhone.split("转");

                    // 必须有且只有两部分：主号码 + 分机号
                    if (parts.length !== 2) {
                        return false;
                    }

                    const [mainNumber, extension] = parts;

                    // 验证分机号必须是数字
                    if (!/^\d+$/.test(extension) || extension === "") {
                        return false;
                    }

                    // 继续验证主号码部分
                    return this.validateMainNumber(mainNumber);
                }

                // 不含"转"字时直接验证号码
                return this.validateMainNumber(cleanedPhone);
            },

            // 验证主号码（手机或座机）
            validateMainNumber(number) {
                debugger
                // 手机号验证：1开头，11位纯数字
                if (/^1\d{10}$/.test(number)) {
                    return true;
                }

                // 座机号验证：区号(3-4位)-号码(7-8位)
                if (/^\d{3,4}-\d{7,8}$/.test(number)) {
                    return true;
                }

                return false;
            },
            handleClick(){
                console.log('提交表单数据:', this.formData);
                if(isNull(this.formData.name)){
                    this.$message.warning('请输入姓名');
                    return;
                }
                if(isNull(this.formData.phone)){
                    this.$message.warning('请输入电话号码');
                    return;
                }else if(!this.validatePhoneNumber(this.formData.phone)){
                    //this.$message.warning('电话格式不正确');
                    //return;
                }
                if(isNull(this.formData.company)){
                    this.$message.warning('请输入公司名称');
                    return;
                }
                if(!isNull(this.formData.email)){
                    if(this.formData === ' '){
                        console.log("null")
                    }else{
                        let isok = validateEmail(this.formData.email)
                        if(!isok){
                            this.$message.warning('邮箱格式不正确');
                            return;
                        }
                    }

                }
                let data = this.formData;
                let that = this;
                this.$HTTP.addConsult(data).then(resp => {
                    if(resp.code == 200){
                        that.$message.success("信息已提交成功!")
                        this.resetForm();
                        that.$emit('showContact', 1);
                    }
                });

            },
            close(){
                this.resetForm();
                this.$emit('showContact', 1);
            }
        }
    };
</script>

<style scoped lang="css">

    .contact-floating {
        position: fixed;
        right: 20px;        /* 调整到更合理的位置 */
        bottom: 20px;       /* 调整到更合理的位置 */
        z-index: 9999;
        width: 450px;       /* 显式设置宽度匹配内容 */
        max-height: 80vh; /* 最大高度为视口的90% */
        height: auto;     /* 高度自适应内容 */
        margin: 0 10px 10px 10px;
        /* 添加弹性滚动容器 */
        display: flex;
        flex-direction: column;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }
    .group_3 {
        box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.25);
        background-color: #fff;
        border-radius: 10px;
        position: relative; /* 改为相对定位 */
        width: 100%;        /* 继承父容器宽度 */
        height: 100%;       /* 继承父容器高度 */
        left: auto;         /* 清除绝对定位 */
        top: auto;          /* 清除绝对定位 */
        /* 添加滚动 */
        overflow-y: auto;
        /* 优化弹性布局 */
        display: flex;
        flex-direction: column;
        padding-bottom: 20px; /* 增加底部内边距 */
        max-height: calc(90vh - 20px);
    }

    .box_11 {
        background-color: rgba(0, 134, 131, 1);
        border-radius: 10px 10px 0px 0px;
        width: 450px;
        min-height: 60px;
        flex-shrink: 0;

        position: sticky;
        top: 0;
        z-index: 1;
    }

    .text_18 {
        width: 80px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin: 20px 0 0 33px;
    }

    .thumbnail_1 {
        width: 20px;
        height: 20px;
        margin: 24px 26px 0 291px;
    }

    .box_12 {
        background-color: rgba(249, 249, 251, 1);
        border-radius: 4px;
        width: 386px;
        height: 47px;
        margin: 24px 0 0 33px;
    }

    .image-text_159 {
        width: 43px;
        height: 22px;
        margin: 13px 0 0 10px;
    }

    .thumbnail_2 {
        width: 8px;
        height: 8px;
        margin-top: 7px;
    }

    .text-group_2 {
        width: 32px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 16px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
    }

    .box_13 {
        background-color: rgba(249, 249, 251, 1);
        border-radius: 4px;
        width: 386px;
        height: 47px;
        margin: 16px 0 0 33px;
    }

    .image-text_160 {
        width: 43px;
        height: 22px;
        margin: 13px 0 0 10px;
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }

     .flex-row {
         display: flex;
         flex-direction: row;
     }

    .thumbnail_3 {
        width: 8px;
        height: 8px;
        margin-top: 7px;
    }

    .text-group_3 {
        width: 32px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 16px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
    }



    .text-wrapper_5 {
        background-color: rgba(249, 249, 251, 1);
        border-radius: 4px;
        height: 47px;
        width: 386px;
        margin: 16px 0 0 33px;
    }

    .text_20 {
        width: 32px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 16px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        margin: 13px 0 0 21px;
    }

    .text-wrapper_6 {
        background-color: rgba(249, 249, 251, 1);
        border-radius: 4px;
        height: 120px;
        width: 386px;
        margin: 13px 0 0 33px;
        flex-shrink: 0;    /* 保持固定高度 */
    }


    .text-wrapper_7 {
        background-color: rgba(0, 134, 131, 1);
        border-radius: 4px;
        height: 42px;
        width: 145px;
        margin: 20px 0 18px 154px;
        flex-shrink: 0;    /* 防止按钮被压缩 */
        cursor: pointer;
    }

    .text_22 {
        width: 40px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin: 7px 0 0 52px;
    }


    .form-input {
        flex: 1; /* 自动填充剩余空间 */
        border: none;
        outline: none;
        background: transparent;
        color: #333;
        font-size: 16px;
        padding-left: 10px; /* 移除左侧内边距 */
    }
    .message-input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        background: transparent;
        resize: none;
        padding: 10px;
        color: #999;
        font-size: 16px;
    }

    @media (max-height: 600px) {
        .contact-floating {
            position: fixed;
            top: auto;
            bottom: 20px;       /* 保持底部间距 */
            right: 20px !important; /* 强制右侧间距 */
            left: auto !important; /* 清除左侧定位 */
            transform: none !important; /* 移除变形 */
            width: calc(100% - 40px); /* 自适应宽度保留间距 */
            max-width: 400px;   /* 保持最大宽度限制 */
            margin: 0;          /* 清除外边距 */
        }

        .group_3 {
            padding: 0 0 10px; /* 减少垂直间距 */
            height: 100%;
        }

        /* 调整标题栏 */
        .box_11 {
            border-radius: 8px 8px 0 0;
            width: 100%;     /* 标题栏宽度自适应 */
            min-height: 45px;
        }
        .text_18 {
            margin: 12px 0 0 20px;
            font-size: 16px;
        }
        .thumbnail_1 {
           /* margin-top: 18px;  */
            margin: 12px 15px 0 auto; /* 自动右边距 */
        }

        /* 压缩表单项间距 */
        .box_12,
        .box_13,
        .text-wrapper_5 {
            height: 42px;      /* 减小输入框高度 */
            margin-top: 12px;  /* 减少间距 */
            width: 90%;        /* 改为相对宽度 */
            margin-left: 5%;   /* 居中显示 */

        }

        /* 调整留言框高度 */
        .text-wrapper_6 {
            height: 70px;     /* 减小高度 */
            width: 90%;
            margin-left: 5%;
        }

        /* 调整按钮位置 */
        .text-wrapper_7 {
            margin: 12px auto;
            width: 100px;
            height: 36px;
        }
        .text_22 {
            font-size: 16px;
            margin: 4px auto;
        }
    }
</style>
